import {useDestinationImage} from "../../hooks/useDestinationImage";
import React from "react";
import DestinationGroupCategoryLabels from "../labels/destinationGroupCategoryLabels";
import {DestinationCategory} from "../../models/DestinationCategory";
import {useTranslation} from "../../i18n/LanguageProvider";

interface Props {
  city: string;
  destinationIata?: string;
  totalFlights: number;
  backgroundImageUrl: string;
  categories: DestinationCategory[];
}

const DestinationGroupHeader: React.FC<Props> = ({
  city,
  destinationIata = "",
  totalFlights,
  backgroundImageUrl,
  categories,
}) => {
  const {t} = useTranslation();
  const {src} = useDestinationImage(destinationIata, "long", backgroundImageUrl);

  return (
    <div className="relative rounded-xl overflow-hidden shadow-card text-white">
      {/* Image background with white border */}
      <div className="absolute inset-0 p-[8px] bg-white rounded-2xl">
        <div className="w-full h-full rounded-[10px] overflow-hidden relative">
          <img
            src={src}
            alt={city}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </div>

      {/* Header content */}
      <div className="relative z-10 px-5 sm:px-7 py-6 sm:py-8 flex flex-col gap-3">
        <div className="flex items-center justify-between flex-wrap gap-y-2">
          {/* Left side: title + category tags */}
          <div className="flex items-center flex-wrap gap-6 min-w-0">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight break-words">{city}</h2>
            {categories.length > 0 && (
              <DestinationGroupCategoryLabels categories={categories} />
            )}
          </div>

          {/* Right side: number of flight options */}
          <span className="text-sm font-extrabold whitespace-nowrap ml-auto">
            {t("flight.available", {count: totalFlights})}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DestinationGroupHeader;
